export default function IconStethoscope({ size = 20 }: { size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 4H5a1 1 0 0 0-1 1v3.5a5.5 5.5 0 0 0 11 0V5a1 1 0 0 0-1-1h-1" />
        <path d="M8 15a6 6 0 0 0 12 0v-3" />
        <path d="M11 3v2M6 3v2" />
        <circle cx="20" cy="10" r="2" />
      </g>
    </svg>
  );
}
